var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeal = function SvgDeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.879.879A3 3 0 0 1 9 0h4a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h3V3A3 3 0 0 1 6.879.879M6 6H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3zm2 12V6h6v12zm8 0h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3zM14 4H8V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z",
    clipRule: "evenodd"
  })));
};
export default SvgDeal;